import { Controller } from "@hotwired/stimulus"

// Switches the config panel based on the selected element kind.
export default class extends Controller {
  static targets = ["attributeConfig", "skillConfig", "mechanicConfig", "conditionConfig"]
  static values = { kind: String }

  connect() {
    this.showConfigForKind(this.kindValue)
  }

  kindChanged(event) {
    this.kindValue = event.target.value
    this.showConfigForKind(this.kindValue)
  }

  showConfigForKind(kind) {
    const panelMap = {
      attribute: "attributeConfig",
      skill: "skillConfig",
      mechanic: "mechanicConfig",
      condition: "conditionConfig",
    }

    const allPanels = ["attributeConfig", "skillConfig", "mechanicConfig", "conditionConfig"]
    allPanels.forEach(target => {
      if (this[`has${this.#capitalise(target)}Target`]) {
        this[`${target}Target`].classList.add("hidden")
      }
    })

    const active = panelMap[kind]
    if (active && this[`has${this.#capitalise(active)}Target`]) {
      this[`${active}Target`].classList.remove("hidden")
    }
  }

  #capitalise(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
}
